
<template>
  <div
    class="pick-background-color"
  >
    <Compact
      class="default-color-list"
      :value="color"
      @input="changeBackgrounColor"
    />
    <Chrome
      class="color-picker"
      :value="color"
      @input="changeBackgrounColor"
    />
  </div>
</template>

<script>
import { Chrome, Compact } from './components/ColorPicker/index'

export default {
  name: 'SimpleApp',
  components: {
    Chrome,
    Compact
  },
  data () {
    return {
      color: ''
    }
  },
  props: {
    currentColor: {
      type: String,
      default: '#ffffff'
    }
  },
  watch:{
    currentColor: {
      immediate: true,
      handler(){
        this.color = this.currentColor
      }
    }
  },
  methods: {
    changeBackgrounColor (colorData, isCover) {
      this.color = colorData.hex
      this.$emit('change', this.color, isCover)
    }
  }
}
</script>


<style>
.base-color-picker {
  width: 300px !important;
  height: 500px !important;
}
</style>
